module.exports = __webpack_public_path__ + "media/raise_capital/court_house_background-5627ca17.jpg";